import { z } from "zod";
import { ZReportChaptersSchema } from "./kapitelSchema";

export const ZEksempelrapportSchema = z.object({
  generellInfo: z.object({
    utarbeidetAv: z.string().min(3),
    kontrollertAv: z.string(),
    godkjentAv: z.string(),
    dokumentNr: z.string(),
    revisjonsNr: z.string(),
  }),
  kapitler: ZReportChaptersSchema
});

export type IEksempelrapport = z.infer<typeof ZEksempelrapportSchema>;
